// extracted by mini-css-extract-plugin
export default {"LanguageSwitcher":"LanguageSwitcher_LanguageSwitcher__vLHEm","LanguageName":"LanguageSwitcher_LanguageName__HzXPw"};